import MortgageFAQItem from './MortgageFAQItem';
import mortgageData from '../../data/mortgage.json';
import styles from '../../styles/modules/mortgage/MortgageFAQ.module.scss';

const MortgageFAQ = () => {
  return (
    <section className={['block', 'crop', styles.faq].join(' ')} id="faq">
      <div className="fixed">
        <h3>Популярные вопросы</h3>
        {mortgageData.map((v, i) => (
          <MortgageFAQItem {...v} key={i} />
        ))}
      </div>
    </section>
  );
};

export default MortgageFAQ;
